import {drawOnFlat} from "./select-on-flat";
import {drawOnFloor} from "./select-on-floor";


export function initDrawingSVG(){
    drawOnFlat();
    drawOnFloor();
}